import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-message', 'close', 'Закрыть');
